import { render, staticRenderFns } from "./SnippetStandard.vue?vue&type=template&id=7713ff31&"
import script from "./SnippetStandard.vue?vue&type=script&lang=js&"
export * from "./SnippetStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports